import { useEffect } from 'react';
import CustomerSearch from '../components/CustomerSearch';
import Header from '../components/Header';

const CustomerScreen = () => {

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
            sessionStorage.setItem("isLoggedIn", "false");
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return (
        <div>
            <Header />
            <CustomerSearch />
        </div>
    );
};

export default CustomerScreen;